// Si la cadena está integrada con un sistema externo, y en qué modo, leído de `getRetailer` en retail-org.
import { useQuery } from '@tanstack/react-query';
import type { RetailIntegrationModeEnum } from '@fiado/type-kit/bin/retailOrg/enums/RetailIntegrationModeEnum';
import { getRetailer } from '@/api/services/retail-org/retail-org.client';
import { integrationModeOf, isIntegratedRetailer } from '../lib/integrationLock';

export const RETAILER_INTEGRATION_KEY = ['retail-admin', 'retailer-integration'] as const;

export interface RetailerIntegration {
    integrated: boolean;
    /** Modo vigente; `null` si la cadena no está integrada o no se ha leído. */
    mode: RetailIntegrationModeEnum | null;
}

/** Mientras carga o si la lectura falla queda como no integrada: el back sigue rechazando con 422. */
export function useRetailerIntegration(retailerId: string | null): RetailerIntegration {
    const query = useQuery({
        queryKey: [...RETAILER_INTEGRATION_KEY, retailerId],
        queryFn: () => getRetailer(retailerId ?? ''),
        enabled: retailerId !== null,
        staleTime: 5 * 60_000,
    });
    return {
        integrated: isIntegratedRetailer(query.data),
        mode: integrationModeOf(query.data),
    };
}

export function useRetailerIntegrated(retailerId: string | null): boolean {
    return useRetailerIntegration(retailerId).integrated;
}
